import { render, staticRenderFns } from "./ReviewRequest.vue?vue&type=template&id=47248a32&"
import script from "./ReviewRequest.vue?vue&type=script&lang=js&"
export * from "./ReviewRequest.vue?vue&type=script&lang=js&"
import style0 from "./ReviewRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports